import React, { StrictMode } from 'react';
import { BrowserRouter } from "react-router-dom";
import { ColorModeScript } from '@chakra-ui/react';

import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <StrictMode>
    <ColorModeScript />
    <BrowserRouter>

    <App />
    </BrowserRouter>

  </StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

